import React, { useEffect, useRef, useState } from 'react';

// Fades an element up into place the first time it scrolls into view — the
// same effect already used for the About page's team cards and the
// Partners page's cards, pulled out here so every other page can share it
// instead of each re-implementing its own IntersectionObserver.
//
// `as` picks the rendered tag (or component, e.g. react-router's `Link`);
// `delay` staggers items in a list (pass `index * 0.05` or similar).
export default function Reveal({ as: Tag = 'div', delay = 0, className = '', style, children, ...rest }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.unobserve(el);
        }
      },
      { threshold: 0.1 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <Tag
      ref={ref}
      className={['reveal', visible && 'reveal-visible', className].filter(Boolean).join(' ')}
      style={delay ? { ...style, animationDelay: `${delay}s` } : style}
      {...rest}
    >
      {children}
    </Tag>
  );
}
